import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMyPartnerDoc } from '../lib/partners';

export default function ProfessionalRoute({ children }) {
  const { authReady, user, getToken } = useAuth();
  const [allow, setAllow] = useState(null);

  useEffect(() => {
    let live = true;
    (async () => {
      if (!authReady) return;
      if (!user) { if (live) setAllow(false); return; }
      
      // Pass getToken to the helper
      const doc = await getMyPartnerDoc(getToken);
      
      const ok = !!doc && (doc.subscriptionStatus === 'active' || doc.subscriptionStatus === 'trialing');
      if (live) setAllow(ok ? true : false);
    })();
    return () => { live = false; };
  }, [authReady, user, getToken]);

  if (!authReady || allow === null) return <div>Loading...</div>;

  return allow ? children : <Navigate to='/partners/subscribe' />;
}
